import styled from 'styled-components';
import { ThemeColours } from '../../styles/ThemeColours';
import { FONT_STACK, FontSize, FontWeight, LineHeight } from '../../styles/constants';
import { AlertIcon } from '../Alert/Alert';
import { buildHeImgixUrl } from '../images/imgix';

export const AnnouncementBannerContainer = styled.div`
  ${FONT_STACK}
  align-items: center;
  background-color: ${ThemeColours.primary50};
  color: ${ThemeColours.primary700};
  display: flex;
  font-size: ${FontSize.REGULAR};
  font-weight: ${FontWeight.SEMI_BOLD};
  justify-content: center;
  line-height: ${LineHeight.REGULAR};
  min-height: 32px;
  padding: 8px;
`;

export const MegaphoneIcon = styled.div`
  background-image: url(${buildHeImgixUrl('public/images/megaphone_20211122061200.svg')});
  background-repeat: no-repeat;
  display: block;
  height: 16px;
  padding: 0 24px 0 0;
  width: 16px;
`;

export const AlertBannerContainer = styled.div`
  ${FONT_STACK}
  align-items: center;
  background-color: ${ThemeColours.notificationWarningBackground};
  color: ${ThemeColours.warning700};
  display: flex;
  font-size: ${FontSize.REGULAR};
  font-weight: ${FontWeight.SEMI_BOLD};
  justify-content: center;
  line-height: ${LineHeight.REGULAR};
  min-height: 32px;
  padding: 8px;
`;

export const SpecialAlertIcon = styled(AlertIcon)`
  height: 20px;
  padding: 0 20px 0 0;
  width: 20px;
`;

export const TitleWrapper = styled.div`
  padding: 0 8px 0 0;
`;

export const AnnouncementCta = styled.a`
  color: ${ThemeColours.primary500};
  text-decoration: underline;
`;

export const AlertCta = styled.a`
  color: ${ThemeColours.warning700};
  text-decoration: underline;
`;
